import { render, staticRenderFns } from "./AssuranceOtherOrganizationPrintHtml.vue?vue&type=template&id=2dfa241d&scoped=true&"
import script from "./AssuranceOtherOrganizationPrintHtml.vue?vue&type=script&lang=js&"
export * from "./AssuranceOtherOrganizationPrintHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa241d",
  null
  
)

export default component.exports